import type { FlagStatus } from '@/types/controlCenter'
import {
  navInputCls,
  navSelectCls,
  addBtnCls,
} from '../components/shared/modalStyles'

export interface FlagsControlsProps {
  statusFilter: FlagStatus | 'all'
  onStatusChange: (v: FlagStatus | 'all') => void
  searchQuery: string
  onSearchChange: (v: string) => void
  canEdit: boolean
  onAdd: () => void
}

const FlagsControls = ({
  statusFilter,
  onStatusChange,
  searchQuery,
  onSearchChange,
  canEdit,
  onAdd,
}: FlagsControlsProps) => (
  <>
    <select
      value={statusFilter}
      onChange={(e) => onStatusChange(e.target.value as FlagStatus | 'all')}
      className={navSelectCls}
    >
      <option value='all'>All status</option>
      <option value='enabled'>Enabled</option>
      <option value='disabled'>Disabled</option>
    </select>
    <input
      type='text'
      value={searchQuery}
      onChange={(e) => onSearchChange(e.target.value)}
      placeholder='Search…'
      className={`${navInputCls} w-[160px]`}
    />
    {canEdit && (
      <button onClick={onAdd} className={addBtnCls}>
        + Add Flag
      </button>
    )}
  </>
)

export default FlagsControls
